// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/**
 * G1 Tasy shutdown (owner, 2026-10-26): results, laudos, authorizations, critical-result alerts, Jasper reports and the
 * protocol sheet come only from the lab system. Until one is integrated (Laborlis, later), every route that served them
 * answers one of the two shapes below, and a screen reads the flag or the code, never an error page.
 */
export const LAB_INTEGRATION_INACTIVE = 'LAB_INTEGRATION_INACTIVE'

/** A lab-only list: 200, inside the usual `data` envelope. */
export const labIntegrationInactiveListSchema = z.object({
    items: z.array(z.unknown()).max(0),
    total: z.literal(0),
    labIntegration: z.literal('inactive'),
})
export type LabIntegrationInactiveList = z.infer<
    typeof labIntegrationInactiveListSchema
>

/** A lab-only document (a laudo, a PDF, a report, the attendance header): 409 with this body. */
export const labIntegrationInactiveErrorSchema = z.object({
    statusCode: z.literal(409),
    status: z.literal('error'),
    error: z.literal(LAB_INTEGRATION_INACTIVE),
    message: z.string(),
})
export type LabIntegrationInactiveError = z.infer<
    typeof labIntegrationInactiveErrorSchema
>

export const isLabIntegrationInactiveList = (
    data: unknown
): data is LabIntegrationInactiveList =>
    labIntegrationInactiveListSchema.safeParse(data).success
